import React from "react";
import { Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import Refresh from "@mui/icons-material/Refresh";
import LockReset from "@mui/icons-material/LockReset";
// import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
// import AccountTreeOutlined from "@mui/icons-material/AccountTreeOutlined";
// import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useColorTheme } from "../context/ColorThemeContext";

// Mapping actionCode to corresponding icon component
export const ActionIconMap = [
  { action: "VIEW", icon: VisibilityOutlined },
  { action: "EDIT", icon: DriveFileRenameOutlineIcon },
  { action: "DELETE", icon: DeleteOutlineIcon },
  { action: "LOCK", icon: LockOutlinedIcon },
  { action: "UNLOCK", icon: LockOpenIcon },
  { action: "HISTORY", icon: AccessTimeOutlinedIcon },
  { action: "RESETPASSWORD", icon: Refresh },
  { action: "RESET2FA", icon: LockReset },
  { action: "RETURNDOCUMENT", icon: LockOutlinedIcon },
  // { action: "ASSIGNROLE", icon: HowToRegOutlinedIcon },
  // { action: "ORGANIZATION", icon: AccountTreeOutlined },
  // { action: "ADDHANDLER", icon: CompareArrowsIcon },
  // { action: "WORKFLOW", icon: AccountTreeOutlined },
  // { action: "DUPLICATE", icon: ContentCopyIcon },
];

// Helper: get icon component by action code
export function getIconComponentByActionCode(code) {
  return ActionIconMap.find((item) => item.action === code)?.icon || null;
}

// Render action icon directly without permission check
export const renderActionDirectly = ({ code, title, onClick }) => {
  const IconComponent = getIconComponentByActionCode(code);
  const colors = useColorTheme();

  if (!IconComponent) return null;

  return (
    <SoftBox display="flex" justifyContent="center">
      <Tooltip title={title} placement="top">
        <IconComponent
          sx={{ color: colors.popupBackground }}
          fontSize="small"
          style={{
            cursor: "pointer",
            marginRight: "8px",
          }}
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        />
      </Tooltip>
    </SoftBox>
  );
};
